import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/web-design-montclair")({
  beforeLoad: () => {
    throw redirect({ to: "/web-design-montclair-ca", statusCode: 301 });
  },
});
